import './Tag.module.css'

import React, { ChangeEventHandler } from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { NavBar } from '../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import { QR } from '@/services/model/qr'
import { MainLayout } from '@/components/layout/MainLayout'
import { Spinner } from '@/components/spinner'
import { useAppContext } from '@/context/app'
import { Roles } from '@/services/repository/users'

type ResponseLastSession = {
  userId: string
  startAt: string
}


type LastChecklist = {
  userId: string
  status: string
  createdAt: string
}

type Response = {
  checklistEnabled: boolean
  inited: boolean
  privileged: boolean
  emachReady: boolean
  machineId: string
  lastSession: ResponseLastSession | null
  lastUserSession: ResponseLastSession | null
  lastChecklist: LastChecklist | null
  lastUserChecklist: LastChecklist | null
}

export const QRTag = () => {
  const navigate = useNavigate();
  const { services, session, translates } = useAppContext()
  const [permissionsError, setPermissionsError] = useState<boolean>(false)
  const [generalError, setGeneralError] = useState<boolean>(false)

  const qrid = useParams().id

  if (session === undefined) {
    return <Spinner />
  }

  function hasRole(roles: Roles[]): boolean {
    const role = session?.user.role as Roles
    return role && roles.includes(role)
  }

  function routing(resp: Response) {
    const role = session?.user.role as Roles
    setPermissionsError(false)
    if (hasRole([Roles.SuperAdmin, Roles.HyperAdmin])) {
      if (!resp.inited) {
        navigate(`/qr/activate/${qrid}`, { replace: true })
        return
      }
      navigate(`/communal/machine/${resp.machineId}`, { replace: true })
      return
    }

    if (!resp.inited) {
      setPermissionsError(true)
      return
    }

    if (hasRole([Roles.Operator])) {
      if (!resp.privileged) {
        setPermissionsError(true)
        return
      }
      if (!resp.emachReady) {
        setGeneralError(true)
        return
      }

      // check if wizard is required
      // const isOlderThan8Hours = (startAt: string): boolean => {
      //   const EIGHT_HOURS = 8 * 60 * 60 * 1000;
      //   const lastStarted = startAt
      //     ? new Date(startAt).getTime()
      //     : null
      //   return !!(lastStarted && (Date.now() - lastStarted >= EIGHT_HOURS))
      // }
      // if (!resp.lastSession || resp.lastSession.userId != session?.user.id
      //   || !resp.lastChecklist || resp.lastChecklist.status !== 'success' || resp.lastChecklist.userId != session?.user.id
      //   || isOlderThan8Hours(resp.lastSession.startAt)
      //   || isOlderThan8Hours(resp.lastChecklist.createdAt)) {
      //   navigate(`/communal/machine/${resp.machineId}/checklist/wizard`)
      //   return
      // }

      const isOlderThan8Hours = (startAt: string): boolean => {
        const EIGHT_HOURS = 8 * 60 * 60 * 1000;
        const lastStarted = startAt
          ? new Date(startAt).getTime()
          : null
        return !!(lastStarted && (Date.now() - lastStarted >= EIGHT_HOURS))
      }
      if (resp.checklistEnabled && (!resp.lastUserChecklist || resp.lastUserChecklist.userId != session?.user.id
        || isOlderThan8Hours(resp.lastUserChecklist.createdAt))) {
        navigate(`/communal/machine/${resp.machineId}/checklist/wizard`, { replace: true })
        return
      }

      // activate page
      navigate(`/communal/machine/${resp.machineId}/activate`, { replace: true })
      return
    }

    //others
    navigate(`/communal/machine/${resp.machineId}`, { replace: true })
    return
  }

  useEffect(() => {
    setGeneralError(false)
    const fetchURL = `/api/communal/qr/byid/${qrid}/codeinfo`
    services.session.fetchWithToken(fetchURL).then((resp) => {
      if (!resp.ok) {
        setGeneralError(true)
        console.error(`${fetchURL} fetch data error`)
        return
      }
      resp.json().then((data) => {
        routing(data)
      })
    })
  }, [qrid])

  if (!permissionsError && !generalError) {
    return <Spinner />
  }

  return <MainLayout services={services} translates={translates} pageName='qrtag'>
    {permissionsError ? <div className="critic-error-box">{translates?.for('errors.no_permissions')}</div> : null}
    {generalError ? <div className="critic-error-box">{translates?.for('errors.general_error')}</div> : null}
  </MainLayout>
}

